import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'

import main from './main'
import i18n from './i18n'
import ui from './ui'
import user from './user'
import planning from './planning'
import crops from './crops'
import products from './products'
import shoppingcart from './shoppingcart'
import { vuei18n } from '../plugins/VueI18n'
import types from './globaltypes'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    main,
    i18n,
    ui,
    user,
    planning,
    crops,
    products,
    shoppingcart
  }
})

store.watch(
  (state, getters) => {
    return {
      locale: state.user.locale,
      localeCode: getters[types.user.getters.localeCode]
    }
  }, ({ locale, localeCode }) => {
    vuei18n.locale = locale
    moment.locale(localeCode)
  }
)

export default store
